export const isCompleteCustomerInfo = (obj) => {
  return Boolean(
    obj?.correoAdquiriente?.trim() && obj?.nombreAdquiriente?.trim()
  );
};
